import {
  JsonapiEntity,
  OneUnresolvedIdentifierOr,
  attribute,
  entity,
  link,
  meta,
  relationship,
} from '@talisdev/jsonapi-transformers';

import { ReadingListDetails } from '®shared/reading-list/models';
import { UserRecord } from '®shared/user/user-record';

type OneUnresolvedIdentifierOrList =
  OneUnresolvedIdentifierOr<ReadingListDetails>;

@entity({ type: 'reviews' })
export class Review extends JsonapiEntity<Review> {
  @attribute() status?: string;

  @link() review_url?: string;

  @meta() requested_at?: string;
  @meta() started_at?: string;
  @meta() completed_at?: string;

  @relationship() requested_by?: UserRecord;
  @relationship() started_by?: UserRecord;
  @relationship() completed_by?: UserRecord;

  @relationship({ allowUnresolvedIdentifiers: true })
  list?: OneUnresolvedIdentifierOrList;
}
